import React from 'react';

import { GlobeImage } from 'assets/icons';
import FormBody from 'components/FormBody';
import FormHeader from 'components/FormHeader';
import { PhoneIcon } from 'components/Icons';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';

import styles from './UnfreezeCredit.module.scss';

interface OrganizationInfo {
  name: string;
  email: string;
  emailHref: string;
  phone: string;
}

const organizationsInfo: OrganizationInfo[] = [
  {
    name: 'Experian',
    email: 'www.experian.com',
    emailHref: 'https://www.experian.com/freeze/center.html',
    phone: '(888) 397-3742',
  },
  {
    name: 'Equifax',
    email: 'www.equifax.com',
    emailHref: 'https://my.equifax.com/membercenter/#/login',
    phone: '(888) 298-0045',
  },
];

const UnfreezeCredit = () => {
  return (
    <>
      <FormHeader
        title="Unfreeze and/or unlock your credit to continue your application "
        subtitle="Contact the below credit bureau(s) that HFS works with to unfreeze your credit."
        percent={ProgressBarStatus.Failed}
      />
      <FormBody>
        {organizationsInfo.map((organization) => (
          <div key={organization.name} className={styles.infoContainer}>
            <p className={styles.organizationName}>{organization.name}</p>
            <div>
              <GlobeImage className={styles.image} />
              <a href={organization.emailHref} className={styles.link}>
                {organization.email}
              </a>
            </div>
            <div>
              <PhoneIcon className={styles.image} />
              <a className={styles.phoneLink} href={`tel:${organization.phone}`}>
                {organization.phone}
              </a>
            </div>
          </div>
        ))}
        <p className={styles.onceYourCredit}>Once your credit is unlocked, you can reapply.</p>
        <p className={styles.onceYourCredit}>
          If you feel you need assistance, please contact HFS Financial at{' '}
          <a className={styles.phoneLink} href={'tel:855-931-5733'}>
            855-931-5733
          </a>{' '}
          or{' '}
          <a className={styles.link} href={'mailto:info@hfsfin.com'}>
            info@hfsfin.com.
          </a>
        </p>
      </FormBody>
    </>
  );
};

export default UnfreezeCredit;
